<ng-container *ngIf="inlineAddMode && isAddSN; else defaultMemberTemplate">
  <div class="inline-member-section" [testId]="'member-inline-add-mode'">
    <div class="section-label">{{ 'servicenumber.member.title' | i18n }} <span class="required-mark">*</span></div>

    <div class="inline-member-card">
      <div class="picker-title">{{ 'servicenumber.member.addMember' | i18n }}</div>
      <nz-input-group [nzPrefix]="searchIcon" class="member-search-input">
        <input
          nz-input
          [(ngModel)]="memberSearchKeyword"
          (ngModelChange)="onInlineSearchChange($event)"
          [placeholder]="'servicenumber.member.pleaseSelectEmployee' | i18n"
          [testId]="'member-inline-search-input'"
        />
      </nz-input-group>
      <ng-template #searchIcon>
        <i nz-icon nzType="search"></i>
      </ng-template>

      <div
        class="candidate-list"
        *ngIf="selectableEmployees.length > 0; else emptyCandidates"
        (scroll)="onCandidateListScroll($event)"
        [testId]="'member-inline-candidate-list'"
      >
        <div class="candidate-item" *ngFor="let employee of selectableEmployees" [testId]="'member-inline-candidate-' + employee.id">
          <div class="candidate-info">
            <nz-avatar [nzSrc]="employee.avatarUrl || employee.avatar" [nzText]="employee.name?.charAt(0) || '?'" [nzSize]="36" />
            <div class="candidate-meta">
              <div class="candidate-name">{{ employee.name }}</div>
              <div class="candidate-subtitle" *ngIf="getEmployeeSubtitle(employee)">{{ getEmployeeSubtitle(employee) }}</div>
            </div>
          </div>
          <button
            nz-button
            nzType="link"
            class="candidate-add-btn"
            (click)="addInlineMember(employee)"
            [testId]="'member-inline-add-btn-' + employee.id"
          >
            <i nz-icon nzType="plus"></i>
          </button>
        </div>

        <div class="candidate-list-status" *ngIf="employeeLoading">
          <span *ngIf="employeeLoading">{{ 'common.loading' | i18n }}</span>
        </div>
      </div>

      <ng-template #emptyCandidates>
        <nz-empty nzNotFoundImage="simple" />
      </ng-template>
    </div>

    <div
      class="selected-member-card"
      *ngFor="let member of localMembers"
      [testId]="'member-inline-selected-' + (member.id || member.employeeId)"
    >
      <div class="selected-member-info">
        <nz-avatar [nzSrc]="member.avatarUrl" [nzText]="member.memberName?.charAt(0) || '?'" [nzSize]="36" />
        <div class="selected-member-meta">
          <div class="selected-member-name">{{ member.memberName }}</div>
          <div class="selected-member-subtitle" *ngIf="member.email || member.departmentName">
            {{ getEmployeeSubtitle(member) }}
          </div>
        </div>
      </div>

      <div class="selected-member-actions">
        <nz-select
          class="inline-privilege-select"
          [ngModel]="member.privilege"
          (ngModelChange)="updateInlinePrivilege(member, $event)"
          [testId]="'member-inline-privilege-select-' + (member.id || member.employeeId)"
        >
          <nz-option *ngFor="let option of privilegeOptions" [nzValue]="option.value" [nzLabel]="option.label" />
        </nz-select>
        <button
          nz-button
          nzType="link"
          class="remove-member-btn"
          (click)="removeInlineMember(member)"
          [testId]="'member-inline-remove-btn-' + (member.id || member.employeeId)"
        >
          <i nz-icon nzType="delete"></i>
        </button>
      </div>
    </div>

    <div class="member-summary">
      <span>{{ 'common.total-records' | i18n: { total: localMembers.length } }}</span>
      <span>{{ 'servicenumber.member.privilege.owner' | i18n }}: {{ selectedOwnerCount }}</span>
      <span>{{ 'servicenumber.member.privilege.manager' | i18n }}: {{ selectedManagerCount }}</span>
      <span>{{ 'servicenumber.member.privilege.common' | i18n }}: {{ selectedCommonCount }}</span>
    </div>
  </div>
</ng-container>

<ng-template #defaultMemberTemplate>
  <nz-card [nzTitle]="'servicenumber.member.title' | i18n" [nzExtra]="extraTemplate" [testId]="'member-main-card'">
    <ng-template #extraTemplate [testId]="'member-extra-template'">
      <div class="member-card-actions">
        <button
          *ngIf="!isAddSN"
          nz-button
          type="button"
          class="refresh-member-button"
          [disabled]="loading"
          (click)="refreshMemberList()"
          [testId]="'refresh-member-button'"
        >
          <i nz-icon nzType="reload" nzTheme="outline" [testId]="'refresh-member-icon'"></i>
          {{ 'common.refresh' | i18n }}
        </button>
        <button nz-button nzType="primary" type="button" (click)="showAddMemberModal()" [testId]="'add-member-button'">
          <i nz-icon nzType="user-add" [testId]="'add-member-icon'"></i>{{ 'servicenumber.member.add' | i18n }}
        </button>
      </div>
    </ng-template>

    <nz-table
      [testId]="'member-table'"
      #memberTable
      [nzData]="memberList"
      [nzLoading]="loading"
      nzShowSizeChanger
      [nzPageSize]="pageSize"
      [nzPageIndex]="pageIndex"
      [nzFrontPagination]="false"
      [nzShowPagination]="true"
      [nzTotal]="total"
      nzSize="small"
      (nzPageIndexChange)="pageIndexChange($event)"
      (nzPageSizeChange)="pageSizeChange($event)"
      class="member-table"
    >
      <thead [testId]="'member-table-head'">
        <tr [testId]="'member-table-header-row'">
          <th scope="col" [testId]="'member-name-header'">{{ 'servicenumber.member.member' | i18n }}</th>
          <th scope="col" [testId]="'member-privilege-header'">{{ 'servicenumber.member.privilege' | i18n }}</th>
          <th scope="col" [testId]="'member-join-time-header'">{{ 'servicenumber.member.joinTime' | i18n }}</th>
          <th scope="col" [testId]="'member-actions-header'">{{ 'servicenumber.member.actions' | i18n }}</th>
        </tr>
      </thead>
      <tbody [testId]="'member-table-body'">
        <tr *ngFor="let member of memberTable.data" [testId]="'member-table-row-' + (member.id || member.employeeId)">
          <td [testId]="'member-name-cell'">{{ member.memberName }}</td>
          <td [testId]="'member-privilege-cell'">
            <nz-tag [nzColor]="getPrivilegeTagColor(member.privilege)" class="privilege-tag" [testId]="'member-privilege-tag'">
              {{ getPrivilegeLabel(member.privilege) }}
            </nz-tag>
          </td>
          <td [testId]="'member-join-time-cell'">{{ member.joinTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
          <td class="action-column" [testId]="'member-actions-cell'">
            <!-- 拥有者没有操作按钮 -->
            <ng-container *ngIf="member.privilege !== 'Owner' || isAddSN" [testId]="'member-actions-container'">
              <a
                class="action-link"
                [class.disabled-action]="loading"
                (click)="!loading && showEditMemberModal(member)"
                [testId]="'edit-member-link'"
              >
                <i nz-icon nzType="edit" nzTheme="outline" [testId]="'edit-member-icon'"></i> {{ 'servicenumber.member.edit' | i18n }}
              </a>
              <nz-divider nzType="vertical" [testId]="'member-actions-divider-1'" />
              <a
                class="action-link"
                [class.disabled-action]="loading"
                nz-popconfirm
                [nzPopconfirmTitle]="'servicenumber.member.transferOwnerConfirm' | i18n"
                nzPopconfirmPlacement="bottom"
                *ngIf="showTransferButton(member)"
                (nzOnConfirm)="transferOwnership(member.memberId)"
                [testId]="'transfer-owner-link'"
              >
                <i nz-icon nzType="crown" nzTheme="outline" [testId]="'transfer-owner-icon'"></i>
                {{ 'servicenumber.member.setAsOwner' | i18n }}
              </a>
              <nz-divider nzType="vertical" *ngIf="showTransferButton(member)" [testId]="'member-actions-divider-2'" />
              <a
                class="action-link delete-link"
                [class.disabled-action]="loading"
                nz-popconfirm
                [nzPopconfirmTitle]="'servicenumber.member.deleteConfirm' | i18n"
                nzPopconfirmPlacement="bottom"
                (nzOnConfirm)="deleteMember(member.memberId)"
                [testId]="'delete-member-link'"
              >
                <i nz-icon nzType="delete" nzTheme="outline" [testId]="'delete-member-icon'"></i> {{ 'servicenumber.member.delete' | i18n }}
              </a>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-card>

  <nz-modal
    [(nzVisible)]="isModalVisible"
    [nzTitle]="isEditing ? ('servicenumber.member.editMember' | i18n) : ('servicenumber.member.addMember' | i18n)"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="handleSubmit()"
    [nzOkLoading]="isConfirmLoading"
    [nzContent]="modalContent"
    class="member-modal"
    [testId]="'member-modal'"
  >
    <ng-template #modalContent [testId]="'member-modal-content'">
      <form nz-form [formGroup]="memberForm" class="member-form" [testId]="'member-form'">
        <nz-form-item [testId]="'member-name-form-item'">
          <nz-form-label [nzSpan]="6" nzRequired [testId]="'member-name-label'">{{ 'servicenumber.member.member' | i18n }}</nz-form-label>
          <nz-form-control [nzSpan]="16" [nzErrorTip]="'servicenumber.member.pleaseSelectMember' | i18n" [testId]="'member-name-control'">
            <div class="employee-selector" [testId]="'employee-selector'">
              <input
                nz-input
                formControlName="memberName"
                [placeholder]="'servicenumber.member.pleaseSelectEmployee' | i18n"
                readonly
                class="employee-input"
                [testId]="'member-name-input'"
              />
              <button
                nz-button
                nzType="primary"
                (click)="openEmployeeSelector()"
                [disabled]="isEditing"
                nz-tooltip
                [nzTooltipTitle]="'servicenumber.member.selectEmployee' | i18n"
                class="select-icon-btn"
                [testId]="'select-employee-button'"
              >
                <i nz-icon nzType="search" [testId]="'select-employee-icon'"></i>
              </button>
            </div>
            <input type="hidden" formControlName="memberId" [testId]="'member-id-hidden-input'" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item [testId]="'member-privilege-form-item'">
          <nz-form-label [nzSpan]="6" nzRequired [testId]="'member-privilege-label'">{{
            'servicenumber.member.privilege' | i18n
          }}</nz-form-label>
          <nz-form-control
            [nzSpan]="16"
            [nzErrorTip]="'servicenumber.member.pleaseSelectPrivilege' | i18n"
            [testId]="'member-privilege-control'"
          >
            <nz-select
              formControlName="privilege"
              [nzPlaceHolder]="'servicenumber.member.pleaseSelectRole' | i18n"
              class="privilege-select"
              [testId]="'member-privilege-select'"
            >
              <nz-option
                *ngFor="let option of getAvailablePrivilegeOptions()"
                [nzValue]="option.value"
                [nzLabel]="option.label"
                [testId]="'member-privilege-option-' + option.value"
              />
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-template>
  </nz-modal>
</ng-template>
